import { IApplicationState } from '../../types/redux';

export const selectUserName = (state: IApplicationState): string => {
  const { firstName, lastName } = state.userData || {};

  return [firstName, lastName].filter(Boolean).join(' ');
};
